import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { formatPhoneNumber } from '../../../../Utils/phoneUtils';
import FetchModule from '../../../Share/Network/FetchModule';
import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme, getColor } from '../../../../Styles/theme';

import NewSearchInput from '../../../../Component/ClassManageComponent/NewSearchInput';
import CountryCodeSelectBox from '../../../../Component/Common/CountryCodeSelectBox';
import GuestNameInput from '../../../../Component/ClassManageComponent/GuestNameInput';
import GuestPhoneInput from '../../../../Component/ClassManageComponent/GuestPhoneInput';
import NewGuestPhoneInput from '../../../../Component/ClassManageComponent/NewGuestPhoneInput';
import NewGuestNameInput from '../../../../Component/ClassManageComponent/NewGuestNameInput';
import GenderSelectBox from '../../../../Component/ClassManageComponent/GenderSelectBox';
import UserProfile from '../../../../Component/Normal/UserProfile';
import SelectReserveAndQueueModal from './SelectReserveAndQueueModal';
import MemberReservationInfoBox from './MemberReservationInfoBox';
import ReservedMemberInfoBox from './ReservedMemberInfoBox';
import QueuedMemberInfoBox from './QueuedMemberInfo';
import CancelledMemberInfoBox from './CancelledMemberInfoBox';

import DownImage from '../../../../image/down.png';
import UpImage from '../../../../image/up.png';
import WhiteArrowImage from '../../../../image/WhiteArrow.png';
import UnLockImage from '../../../../image/UnLockImage.png';
import LockImage from '../../../../image/LockImage.png';
import AttendancePlus from '../../../../image/AttendancePlus.png';
import AttendanceExit from '../../../../image/AttendanceExit.png';
import GuestProfileIcon from '../../../../image/ReserveGuestProfile.png';
import { ReactComponent as LockSvg } from '../../../../image/Lock.svg';
import { ReactComponent as UnlockSvg } from '../../../../image/Unlock.svg';
import { ReactComponent as PlusSvg } from '../../../../image/Plus.svg';

export default function NewMemberReservationModal(props) {
  const {
    data,
    cancel,
    isCanceledSchedule,
    reserveDataReLoad,
    setReserveDataReLoad,
    scheduleData
  } = props;

  const [memberList, setMemberList] = useState([]);
  const [useMemberList, setUseMemberList] = useState([]);
  const [useReserveList, setUseReserveList] = useState([]);
  const [useQueueList, setUseQueueList] = useState([]);

  const [useCancelList, setUseCancelList] = useState([]);
  const [isExistSubList, setIsExistSubList] = useState(false);

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { languageMode, t } = useLanguage();

  const [lessonBoxColor, setLessonBoxColor] = useState('#FF8B48');
  const [isKorea, setIsKorea] = useState(false);
  const [classTime, setIsClassTime] = useState(false);
  const [originalMaxBookedPeople, setOriginalMaxBookedPeople] = useState(0);
  const [modifyMaxBookedPeople, setModifyMaxBookedPeople] = useState('');

  const [isClickedLock, setIsClickedLock] = useState(false);

  const [isInProgress, setIsInProgress] = useState(false);
  const [rendering, setRendering] = useState(false);

  const [guestName, setGuestName] = useState('');
  const [guestNameError, setGuestNameError] = useState(false);
  const [guestGender, setGuestGender] = useState('Female');
  const [guestPhone, setGuestPhone] = useState('');
  const [noHavePhone, setNoHavePhone] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState({ countryCode: '+82', flagUrl: 'https://picture.link-zone.org/flags/kr.svg', countryNameKR: '대한민국', countryNameEN: 'South Korea' });

  const [searchData, setSearchData] = useState('');

  const [maxQueue, setMaxQueue] = useState(0);

  const [isAddGuest, setIsAddGuest] = useState(false);

  const [memberSearchViewHeight, setMemberSearchViewHeight] = useState(511);
  const [addGuestHeight, setAddGuestHeight] = useState(0);

  const [isMounted, setIsMounted] = useState(false);

  const [openChoiceButtonIndex, setOpenChoiceButtonIndex] = useState(undefined);

  const ClassNameRef = useRef(null);
  const MaxBookedPeopleInputRef = useRef(null);
  const history = useHistory();


  // 마운트 후 transition 활성화 //
  useEffect(() => {
    setIsMounted(true);
  }, [])

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  // 수업 이름 색상 정하기 //
  useEffect(() => {
    setLessonBoxColor(getColor(scheduleData.color, isDark));
  }, [scheduleData, isDark])

  // 수업 시간뷰 정리 및 API 호출 //
  useEffect(() => {
    const korea = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

    let requestData = {
      scheduleId: scheduleData.scheduleId,
      classDate: scheduleData.classDate.replaceAll('.', '-') + 'T00:00:00'
    }
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/status', 'POST', requestData);

        if (responseData.status === 200) {
          setIsClickedLock(responseData.data.isLock);
          setMemberList(responseData.data.availableMembers);
          setUseReserveList(responseData.data.reserveMembers);
          setUseQueueList(responseData.data.queueMembers);
          setMaxQueue(responseData.data.maxQueue);

          let cancelMembers = responseData.data.cancelMembers || [];

          setUseCancelList(cancelMembers);
          setIsExistSubList(responseData.data.queueMembers.length > 0 || cancelMembers.length > 0);

          setIsInProgress(false);

          // 최대예약인원 변경 내역이 존재할 경우 //
          if (responseData.data.modifiedMaxBookedPeople !== -1) setOriginalMaxBookedPeople(responseData.data.modifiedMaxBookedPeople);
          // 최대 예약인원 변경 내역이 없을경우 //
          else setOriginalMaxBookedPeople(scheduleData.maxBookedPeople);


        }
      }
    )();

    if (korea.test(scheduleData.className)) setIsKorea(true);

    let classTime = scheduleData.classTime.split('-');
    let startTime = '';
    let endTime = '';

    if (classTime[0].split(':')[0] >= 12) startTime = classTime[0] + ' PM';
    else startTime = classTime[0] + ' AM'

    if (classTime[1].split(':')[0] >= 12) endTime = classTime[1] + ' PM';
    else endTime = classTime[1] + ' AM';

    setIsClassTime(startTime + ' ~ ' + endTime);
    setIsInProgress(false);
  }, [scheduleData, rendering])

  // 유효회원권 소지한 회원 명단 추출 //
  useEffect(() => {
    let findData = [];

    if (searchData !== '') {
      for (let i = 0; i < memberList.length; i++) {
        if (memberList[i].name.toLowerCase().includes(searchData.toLowerCase()) || memberList[i].phone.includes(searchData)) findData.push(memberList[i]);
      }
    }
    else {
      findData = memberList.slice();
    }


    setGuestName('');
    setGuestPhone('');

    setMemberSearchViewHeight(511);

    setAddGuestHeight(0);

    setUseMemberList(findData);
  }, [memberList, data, reserveDataReLoad, searchData, isExistSubList])

  // 수업 이름 박스 옆 수업 데이터 텍스트 최대 크기 결정 //
  function decideClassInfoTextWidth() {
    let boxWidth = ClassNameRef.current?.offsetWidth;

    return 370 - boxWidth - 6;
  }

  // 수업 정원 창 클릭시 //
  function onClickModifyMaxBookedPeople() {
    MaxBookedPeopleInputRef.current?.focus();
  }

  // 회원 예약 버튼 클릭시 //
  function onClickMemberReserveButton(index) {
    if (isClickedLock) {
      alert(t('reservation.reservationLocked'));
      return;
    }
    else if (isInProgress) {
      alert(t('reservation.inProgress'));
      return;
    }

    setIsInProgress(true);
    
    let requestData = {
      scheduleId: scheduleData.scheduleId,
      usageId: useMemberList[index].usageId,
      linkCoachId: useMemberList[index].userId,
      classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00",
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const reserveResponseData = await fetchModule.postDataVersion2('reserve/create/manager', 'POST', requestData);
    
        if (reserveResponseData.status === 200) {
          setReserveDataReLoad(!reserveDataReLoad);
          setRendering(!rendering);
    
          setSearchData('');
          setIsInProgress(false);
        }
        else if (reserveResponseData.status === 201) {
          alert(t('reservation.invalidMembership'));
          setIsInProgress(false);
        }
        else if (reserveResponseData.status === 202) {
          alert(t('reservation.alreadyReserved'));
          setIsInProgress(false);
        }
        else if (reserveResponseData.status === 203) {
          alert(t('reservation.alreadyCanceled'));
          setIsInProgress(false);
        }
      }
    )();
  }

  // 회원 예약 취소 버튼 클릭시 //
  function onClickMemberExceptButton(index) {
    if (isInProgress) {
      alert(t('reservation.inProgress'));
      return;
    }

    setIsInProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + useReserveList[index].reserveId, 'POST');

        if (responseData.status === 200) {
          setReserveDataReLoad(!reserveDataReLoad);
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }

  // 수업 정원 변경 //
  function onChangeModifyMaxBookedPeople(e) {
    let check = /^[0-9]+$/;

    if (check.test(e.target.value)) {
      setModifyMaxBookedPeople(e.target.value);
    }
    else if (e.target.value === '') setModifyMaxBookedPeople('');
  }

  // 수업 정원 증가 클릭 //
  function upButtonClick() {
    if (modifyMaxBookedPeople === '') {
      setModifyMaxBookedPeople(originalMaxBookedPeople + 1);
    }
    else setModifyMaxBookedPeople(modifyMaxBookedPeople + 1);
  }

  // 수업 정원 감소 클릭 //
  function downButtonClick() {
    if (modifyMaxBookedPeople > 0) {
      setModifyMaxBookedPeople(modifyMaxBookedPeople - 1);
    }
    else if (modifyMaxBookedPeople === 0) setModifyMaxBookedPeople('');
    else if (modifyMaxBookedPeople === '') {
      if (originalMaxBookedPeople > 0) setModifyMaxBookedPeople(originalMaxBookedPeople - 1);
    }
  }

  // 예약 잠금 버튼 클릭시 //
  function onClickReserveLockButton() {
    if (isInProgress) {
      alert(t('reservation.inProgress'));
      return;
    }

    setIsInProgress(true);

    let requestData = {
      scheduleId: scheduleData.scheduleId,
      classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00",
    }

    // 예약 잠금 풀기 //
    if (isClickedLock) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/unlock', 'POST', requestData);

          if (responseData.status === 200) {
            setReserveDataReLoad(!reserveDataReLoad);
            setRendering(!rendering);
            setIsClickedLock(false);
            setIsInProgress(false);
          }
          else if (responseData.status === 201) {
            alert(t('reservation.invalidAccess'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    // 예약 잠금하기 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/lock', 'POST', requestData);
          
          if (responseData.status === 200) {
            setReserveDataReLoad(!reserveDataReLoad);
            setRendering(!rendering);
            setIsClickedLock(true);
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
  }

  // 닫기 버튼 클릭시 //
  function onClickExit() {
    // 수업 정원이 기본형태가 아닌경우 //
    if (modifyMaxBookedPeople !== '') {
      // 원본 수업 정원과 같지 않을경우 실행 //
      if (originalMaxBookedPeople !== modifyMaxBookedPeople) {
        // console.log("??");
        let requestData = {
          scheduleId: scheduleData.scheduleId,
          classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00",
          modifyMaxBookedPeople: modifyMaxBookedPeople
        }

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('max_booked/save', 'POST', requestData);

            if (responseData.status === 200) {
              setReserveDataReLoad(!reserveDataReLoad);
              // setRendering(!rendering);
              // setIsClickedLock(true);
              // setIsInProgress(false);
            }
            else if (responseData.status === 401) history.push('/login');
          }
        )();
      }
    }
    cancel();
  }

  // 회원 이름 또는 사진 클릭시 //
  function onClickMemberProfileOrText(data) {
    // console.log(data);
    if (data.memberId === 0 && data.userId.includes('Guest-')) {
      alert(t('reservation.guestCannotView'));
      return;
    }
    else window.open('/member/valid/detail/' + data.memberId, '_blank');
  }

  // 회원 전화번호 표시 //
  function onViewUserPhone(phone, countryCode) {
    if (!phone || phone === '') return t('reservation.noPhone');
    return formatPhoneNumber(phone, countryCode, languageMode) || t('reservation.noPhone');
  }

  // 출석 버튼 텍스트 결정 //
  function onCalcButtonText(data) {
    if (data.status === 1 || data.status === 2) return t('reservation.attendanceApprove');
    else return t('reservation.attendanceConfirm');
  }

  // 출석 버튼 클릭시 //
  function onClickAttendanceButton(data) {
    if (data.status === 0 || data.status === 3) {
      let requestData = {
        reserveId: data.reserveId,
        status: 1
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('reservation.attendanceComplete'));
            setUseReserveList(prev => prev.map(m =>
              m.reserveId === data.reserveId ? { ...m, status: 1 } : m
            ));
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      let requestData = {
        reserveId: data.reserveId,
        status: 3
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('reservation.attendanceCanceled'));
            setUseReserveList(prev => prev.map(m =>
              m.reserveId === data.reserveId ? { ...m, status: 3 } : m
            ));
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
  }

  // 게스트 추가 버튼 클릭시 //
  function onClickAddGuest() {
    if (isAddGuest) {
      return;
    }

    if (guestName.trim() === '') {
      setGuestNameError(true);
      return;
    }

    setIsAddGuest(true);

    let name = guestName;
    let phone = noHavePhone ? '' : guestPhone;

    // if (!noHavePhone && phone !== '' && phone.length < 13) {
    //   alert('전화번호를 올바르게 입력해주세요');
    //   setIsAddGuest(false);
    //   return;
    // }

    if (name === '') name = 'Guest';
    if (phone === '') phone = '010XXXXXXXX';
    else phone = phone.replaceAll('-', '');

    let requestData = {
      name: name,
      phone: phone,
      countryCode: selectedCountry.countryCode,
      gender: guestGender.toLowerCase(),
      lessonId: scheduleData.lessonId,
      scheduleId: scheduleData.scheduleId,
      classTime: scheduleData.classTime,
      classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00",
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/create/guest', 'POST', requestData);

        if (responseData.status === 200) {
          setReserveDataReLoad(!reserveDataReLoad);
          setRendering(!rendering);

          setGuestName('');
          setGuestPhone('');
          setSearchData('');

          // setMemberSearchViewHeight(175);
          // setAddGuestHeight(0);
          setMemberSearchViewHeight(511);

          setAddGuestHeight(0);

          setTimeout(() => (
            setIsAddGuest(false)
          ), 700)
        }
        else if (responseData.status === 401) history.push('/login');
        else {
          alert(t('reservation.guestAddFailed'));

          setTimeout(() => (
            setIsAddGuest(false)
          ), 700)
        }
      }
    )();
  }

  // 게스트 추가 버튼 클릭시 //
  function onClickAddGuestOnQueues() {
      if (isAddGuest) {
        return;
      }
  
      if (guestName.trim() === '') {
        setGuestNameError(true);
        return;
      }

      setIsAddGuest(true);

      let name = guestName;
      let phone = noHavePhone ? '' : guestPhone;

      // if (!noHavePhone && phone !== '' && phone.length < 11) {
      //   alert('전화번호를 올바르게 입력해주세요');
      //   setIsAddGuest(false);
      //   return;
      // }

      if (name === '') name = 'Guest';
      if (phone === '') phone = '010XXXXXXXX';
      else phone = phone.replaceAll('-', '');
  
      let requestData = {
        name: name,
        phone: phone,
        countryCode: selectedCountry.countryCode,
        gender: guestGender.toLowerCase(),
        lessonId: scheduleData.lessonId,
        scheduleId: scheduleData.scheduleId,
        classTime: scheduleData.classTime,
        classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00"
      }
  
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve_queue/create/guest', 'POST', requestData);
          // console.log(responseData);
          if (responseData.status === 200) { 
            setReserveDataReLoad(!reserveDataReLoad);
            setRendering(!rendering);

            setGuestName('');
            setGuestPhone('');
            setSearchData('');

            setMemberSearchViewHeight(511);

            setAddGuestHeight(0);

            setTimeout(() => (
              setIsAddGuest(false)
            ), 700)
          }
          else if (responseData.status === 203) {
            alert(responseData.error);

            setTimeout(() => (
              setIsAddGuest(false)
            ), 700)
          }
          else {
            alert(t('reservation.guestAddFailed'));
  
            setTimeout(() => (
              setIsAddGuest(false)
            ), 700)
          }
        }
      )();
  }


  // 예약 대기에서 예약 추가 버튼 클릭시 //
  function onClickAddReserveOnQueue(data) {
    // console.log(data);
    // 맨 위의 대기열인경우 예약자로 변경 //
    if (data.queueIndex === 1) {
      let requestData = {
        reserveQueueId: data.queueId
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/add/zone', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
          }
        }
      )();
    }
    // 대기열 순서 변경 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve_queue/index/' + data.queueId + '/up', 'POST');

          if (responseData.status === 200) {
            setRendering(!rendering);
          }
        }
      )();
    }
  }

  // 예약 대기에서 예약 추가 버튼 클릭시 //
  function onClickDownQueueIndex(data) {
    // console.log(data);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve_queue/index/' + data.queueId + '/down', 'POST');

        if (responseData.status === 200) {
          setRendering(!rendering);
        }
      }
    )();
  }

  // 게스트 정보 입력 버튼 클릭시 //
  function onClickInputGuestInfo() {
    // setMemberSearchViewHeight(0);
    // setAddGuestHeight(175);
    if (isExistSubList) setAddGuestHeight(400);
    else setAddGuestHeight(215);

    setMemberSearchViewHeight(0);
  }

  // 대기열에 추가 하기 //
  function onClickAddQueueButton(index) {
    if (isClickedLock) {
      alert(t('reservation.reservationLocked'));
      return;
    }
    else if (isInProgress) {
      alert(t('reservation.inProgress'));
      return;
    }

    setIsInProgress(true);
    
    let requestData = {
      scheduleId: scheduleData.scheduleId,
      usageId: useMemberList[index].usageId,
      linkCoachId: useMemberList[index].userId,
      classDate: scheduleData.classDate.replaceAll('.', '-') + "T00:00:00",
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('lesson_reserve_queue/save/manager', 'POST', requestData);
        // console.log(responseData);
        if (responseData.status === 200) {
          setReserveDataReLoad(!reserveDataReLoad);
          setRendering(!rendering);

          setSearchData('');
          setIsInProgress(false);
        }
        else if (responseData.status === 201) {
          alert(t('reservation.invalidMembership'));
          setIsInProgress(false);
        }
        else if (responseData.status === 202) {
          alert(t('reservation.alreadyReserved'));
          setIsInProgress(false);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TotalWrapper>
          <TitleWrapper>
            <TitleInnerWrapper>
              <Title>{t('reservation.title')}</Title>
              <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.subText} cursor='default'>{(scheduleData.className + ' | ' + classTime) + (isCanceledSchedule ? ' ' + t('reservation.canceled') : '')}</Text>
            </TitleInnerWrapper>
            <ExitButton onClick={onClickExit}>
              <ExitImage>
                <PlusWidth width={2} height={14} border={4} backgroundColor={theme.subText}/>
                <PlusWidth width={14} height={2} border={4} backgroundColor={theme.subText}/>
              </ExitImage>
            </ExitButton>
          </TitleWrapper>
          <ComponentWrapper>
            <ClassInfoBox>
              {/* <ClassInfoComponentWrapper>
                <ClassDataWrapper>
                  <LessonNameBox 
                    ref={ClassNameRef} 
                    backgroundColor={lessonBoxColor}>
                    <LessonNameInnerWrapper>
                      <Text fontFamily={isKorea ? 'NotoSansKR-Medium' : 'Poppins-Medium'} fontSize={12} color={theme.white} cursor='default'>{scheduleData.className}</Text>
                    </LessonNameInnerWrapper>
                  </LessonNameBox>
                  <ClassTimeWrapper width={decideClassInfoTextWidth()}>
                    <Text style={{ whiteSpace: 'nowrap' }} fontFamily='Poppins-Medium' fontSize={12} color={theme.subText} cursor='default'>{scheduleData.className + ' | ' + classTime}</Text>
                  </ClassTimeWrapper>
                </ClassDataWrapper>
              </ClassInfoComponentWrapper> */}
              <MemberSearchWrapper>
                <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.searchLabel')}</Text>
                <NewSearchInput value={searchData} setValue={setSearchData} placeholder={t('reservation.searchPlaceholder')} type='text' />
              </MemberSearchWrapper>
              <MaxBookedPeopleTotalWrapper>
                <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.classCapacity')}</Text>
                <MaxBookedPeopleAndLockWrapper>
                  <MaxBookedPeopleComponentWrapper>
                    <MaxBookedPeopleWrapper>
                      <MaxBookedInput
                        ref={MaxBookedPeopleInputRef}
                        isLock={isClickedLock}
                        placeholder={originalMaxBookedPeople}
                        value={modifyMaxBookedPeople}
                        onChange={onChangeModifyMaxBookedPeople} 
                        onClick={onClickModifyMaxBookedPeople}/>
                      <LockMaxBookedInput isLock={isClickedLock} >
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white}>{t('reservation.reserveLocked')}</Text>
                      </LockMaxBookedInput>
                    </MaxBookedPeopleWrapper>
                    {/* <MaxBookedPeopleButtonWrapper>
                      <Button onClick={upButtonClick}>
                        <ButtonImage isUp={true} src={WhiteArrowImage}/>
                      </Button>
                      <Button onClick={downButtonClick}>  
                        <ButtonImage isUp={false} src={WhiteArrowImage}/>
                      </Button>
                    </MaxBookedPeopleButtonWrapper> */}
                    <Text style={{ whiteSpace: 'nowrap' }} fontFamily='Poppins-Medium' fontSize={14} color={theme.subText}>{t('reservation.classCapacity')}</Text>
                  </MaxBookedPeopleComponentWrapper>
                  <LockImageWrapper>
                    <StyledUnlock $isLock={isClickedLock} onClick={onClickReserveLockButton} />
                    <StyledLock $isLock={isClickedLock} onClick={onClickReserveLockButton} />
                  </LockImageWrapper>
                </MaxBookedPeopleAndLockWrapper>
              </MaxBookedPeopleTotalWrapper>
            </ClassInfoBox>
          </ComponentWrapper>
          <InfoBoxWrapper>
            <InfoBox>
              <InnerInfoBox height={memberSearchViewHeight} $enableTransition={isMounted}>
                <AddGuestInfoButton onClick={onClickInputGuestInfo}>
                  <StyledPlus />
                  <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('reservation.inputGuestInfo')}</Text>
                </AddGuestInfoButton>
                <ScrollBox>
                  {
                    useMemberList.map((memberData, index) => (
                      <MemberReservationInfoBox
                        key={'ReserveInfo-' + index}
                        memberData={memberData}
                        index={index}
                        nowReserveLength={useReserveList.length}
                        maxReserve={modifyMaxBookedPeople === '' ? originalMaxBookedPeople : modifyMaxBookedPeople}
                        isExistSubList={isExistSubList}
                        openChoiceButtonIndex={openChoiceButtonIndex}
                        setOpenChoiceButtonIndex={setOpenChoiceButtonIndex}
                        onClickMemberProfileOrText={onClickMemberProfileOrText}
                        onClickAddQueueButton={onClickAddQueueButton}
                        onClickMemberReserveButton={onClickMemberReserveButton}/>
                    ))
                  }
                </ScrollBox>
              </InnerInfoBox>
              <InnerInfoBox height={addGuestHeight} $enableTransition={isMounted}>
                <GuestInfoWrapper>
                  <GuestPhoneRowWrapper style={{ marginTop: '5px' }}>
                    <GuestInputWrapper>
                      <GuestInputLabelWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('reservation.guestPhone')}</Text>
                        <NoHavePhoneWrapper onClick={() => setNoHavePhone(!noHavePhone)}>
                          <NoHavePhoneCheckBox $isClicked={noHavePhone} />
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('reservation.noPhoneOption')}</Text>
                        </NoHavePhoneWrapper>
                      </GuestInputLabelWrapper>
                      <GuestPhoneInputRow>
                        <CountryCodeSelectBox selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} disabled={noHavePhone} />
                        <NewGuestPhoneInput value={guestPhone} setValue={setGuestPhone} placeholder={t('reservation.guestPhonePlaceholder')} disabled={noHavePhone} />
                      </GuestPhoneInputRow>
                    </GuestInputWrapper>
                  </GuestPhoneRowWrapper>
                  <GuestNameGenderWrapper>
                    <GuestInputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('reservation.guestName')}</Text>
                      <NewGuestNameInput value={guestName} setValue={(val) => { setGuestName(val); if (val.trim() !== '') setGuestNameError(false); }} placeholder={t('reservation.guestNamePlaceholder')} error={guestNameError} />
                    </GuestInputWrapper>
                    <GuestInputWrapper style={{ flex: 'none', width: '128px' }}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('reservation.gender')}</Text>
                      <GenderSelectBox value={guestGender} setValue={setGuestGender} />
                    </GuestInputWrapper>
                  </GuestNameGenderWrapper>
                </GuestInfoWrapper>
                <ButtonWrapper>
                  <CloseButton onClick={() => { setAddGuestHeight(0); setMemberSearchViewHeight(511); }}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('reservation.close')}</Text>
                  </CloseButton>
                  <TotalAddGuestButtonWrapper>
                    <AddGuestButton width={useQueueList.length > 0 ? '50%' : '100%'} backgroundColor={theme.subKey} onClick={onClickAddGuest}>
                      <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('reservation.addToReserve')}</Text>
                    </AddGuestButton>
                    {
                      useQueueList.length > 0 &&
                      <AddGuestButton width='50%' backgroundColor={theme.pointYellow} onClick={onClickAddGuestOnQueues}>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('reservation.addToQueue')}</Text>
                      </AddGuestButton>
                    }
                  </TotalAddGuestButtonWrapper>
                </ButtonWrapper>
              </InnerInfoBox>
            </InfoBox>
            <StatusInfoBoxWrapper>
              <StatusInfoBox>
                <MemberReserveListTitleWrapper>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.reservedMembers')}</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.countFormat').replace('{current}', useReserveList.length).replace('{max}', modifyMaxBookedPeople === '' ? originalMaxBookedPeople : modifyMaxBookedPeople)}</Text>
                </MemberReserveListTitleWrapper>
                <StatusScrollBox isExistSubList={isExistSubList}>
                  {
                    useReserveList.map((memberData, index) => (
                      <ReservedMemberInfoBox
                        memberData={memberData}
                        index={index}
                        totalLength={useReserveList.length}
                        onViewUserPhone={onViewUserPhone}
                        onCalcButtonText={onCalcButtonText}
                        onClickMemberProfileOrText={onClickMemberProfileOrText}
                        onClickMemberExceptButton={onClickMemberExceptButton}
                        onClickAttendanceButton={onClickAttendanceButton}/>
                    ))
                  }
                </StatusScrollBox>
              </StatusInfoBox>
              {
                useQueueList.length > 0 &&
                <StatusInfoBox style={{ marginTop: '8px' }}>
                  <MemberReserveListTitleWrapper>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.waitingQueue')}</Text>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color='#777777' cursor='default'>{t('reservation.countFormat').replace('{current}', useQueueList.length).replace('{max}', maxQueue)}</Text>
                  </MemberReserveListTitleWrapper>
                  <QueueScrollBox>
                    {
                      useQueueList.map((memberData, index) => (
                        <QueuedMemberInfoBox
                          memberData={memberData}
                          index={index}
                          onViewUserPhone={onViewUserPhone}
                          onClickMemberProfileOrText={onClickMemberProfileOrText}
                          onClickAddReserveOnQueue={onClickAddReserveOnQueue}
                          onClickDownQueueIndex={onClickDownQueueIndex}
                        />
                      ))
                    }
                  </QueueScrollBox>
                </StatusInfoBox>
              }
              {
                useCancelList.length > 0 &&
                <StatusInfoBox style={{ marginTop: '8px' }}>
                  <MemberReserveListTitleWrapper>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('reservation.cancelledMembers')}</Text>
                  </MemberReserveListTitleWrapper>
                  <QueueScrollBox>
                    {
                      useCancelList.map((memberData, index) => (
                        <CancelledMemberInfoBox
                          key={'Cancel-' + index}
                          memberData={memberData}
                          index={index}
                          onViewUserPhone={onViewUserPhone}
                          onClickMemberProfileOrText={onClickMemberProfileOrText} />
                      ))
                    }
                  </QueueScrollBox>
                </StatusInfoBox>
              }
            </StatusInfoBoxWrapper>
          </InfoBoxWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px 0px;

  width: 795px;
  // height: 695px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 94.9%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const TitleInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: 100%;
`;

const ClassInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const MemberSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 49%;

  gap: 10px;
`;

const MaxBookedPeopleTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 49%;

  gap: 10px;
`;

const ClassInfoComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 49%;

  gap: 8px;

  overflow: hidden;
`;

const ClassDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 16px;
  gap: 4px;

  width: 100%;
`;

const LessonNameBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 12px 0px 12px;

  max-width: 153px;
  height: 32px; 

  overflow: hidden;

  border-radius: 5px;
  background-color: ${props => props.backgroundColor};
`;

const LessonNameInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 143px;
  height: 20px;

  overflow: hidden;
`;

const ClassTimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 18px;

  overflow: hidden;
`;

const MaxBookedPeopleAndLockWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const MaxBookedPeopleComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const LockImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

const StyledLock = styled(LockSvg)`
  position: absolute;

  flex-shrink: 0;
  width: 15px;
  height: auto;

  opacity: ${props => props.$isLock ? 1 : 0};

  & path {
    fill: ${props => props.theme.pointRed};
  }

  transition: all 0.3s ease-in-out;
`;

const StyledUnlock = styled(UnlockSvg)`
  flex-shrink: 0;
  width: 15px;
  height: auto;

  opacity: ${props => props.$isLock ? 0 : 1};

  & path {
    fill: ${props => props.theme.gray};
  }

  transition: all 0.3s ease-in-out;
`;

const MaxBookedPeopleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  
  gap: 10px;
`;

const LockMaxBookedInput = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  opacity: ${props => props.isLock ? 1 : 0};
  z-index: ${props => props.isLock ? 3 : -1};

  width: 276.5px;
  height: 35px;

  border-radius: 5px;
  background-color: ${props => props.theme.pointRed};

  transition: all 0.3s ease-in-out;
`;

const MaxBookedInput = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
  text-align: right;

  opacity: ${props => props.isLock ? 0 : 1};

  margin: 0 0 0 0;
  padding: 0 8px 0 8px;

  width: 256.5px;
  height: 33px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	&::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

		color: ${props => props.theme.text};
	}

  transition: all 0.3s ease-in-out;
`;

const MaxBookedPeopleButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 35px;
  height: 35px;

  // border: 1px solid #DFDFDF;
  border-radius: 5px;
  // background: url(${props => props.img}) no-repeat center;
  background-color: ${props => props.theme.gray};

  &:hover {
    cursor: pointer;
  }
`;

const ButtonImage = styled.img`
  width: 17px;
  height: 10px;

  -webkit-transform: ${props => props.isUp ? `rotate(180deg)` : `rotate(0deg)`};
`;

const StatusInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // margin-top: 22px;

  // width: 47.02%;
  width: 49%;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 14px;

  width: 100%;
`;

const StatusInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 49%;
  height: 521px;

  overflow: hidden;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: ${props => props.height}px;

  gap: 30px;

  overflow: ${props => props.height > 0 ? 'visible' : 'hidden'};

  transition: ${props => props.$enableTransition ? 'height 0.3s ease-in-out' : 'none'};
`;

const MemberReserveListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;
`;

const ScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 6px;

  width: 100%;
  height: 465px;

  gap: 7px;

  overflow-y: scroll;
  overflow-x: none;
  
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background: linear-gradient(
      to right,
      transparent 1px,
      ${props => props.theme.line} 1px,
      ${props => props.theme.line} 2px,
      transparent 2px
    );
		border-radius: 200px;
	}
`;

const StatusScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;
  height: ${props => props.isExistSubList ? `208px` : `465px`};
  
  overflow-y: scroll;
  overflow-x: none;

  gap: 5px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background: linear-gradient(
      to right,
      transparent 1px,
      ${props => props.theme.line} 1px,
      ${props => props.theme.line} 2px,
      transparent 2px
    );
		border-radius: 200px;
	}
`;

const QueueScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
  height: 208px;

  gap: 5px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background: linear-gradient(
      to right,
      transparent 1px,
      ${props => props.theme.line} 1px,
      ${props => props.theme.line} 2px,
      transparent 2px
    );
		border-radius: 200px;
	}
`;

const ExitImage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  -webkit-transform: rotate(45deg);

  &:hover {
    cursor: pointer;
  }
`;

const PlusWidth = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: ${props => props.backgroundColor};

  &:hover {
    cursor: pointer;
  }
`;

const ExitButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -8px;
  margin-right: -16px;

  width: 24px;
  height: 24px;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const AddGuestInfoButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: 100%;
  height: 36px;
  flex-shrink: 0;

  gap: 4px;

  border-radius: 8px;
  background-color: ${props => props.theme.primary};

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const GuestInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const GuestPhoneRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-end;

  width: 100%;

  gap: 10px;
`;

const GuestNameGenderWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const NoHavePhoneWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  height: 21px;

  gap: 5px;

  &:hover {
    cursor: pointer;
  }
`;

const NoHavePhoneCheckBox = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 18px;
  height: 18px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.$isClicked ? props.theme.primary : 'transparent'};

  transition: all 0.3s ease-in-out;
`;

const GuestInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  flex: 1;
  min-width: 0;

  gap: 8px;
`;

const GuestInputLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const TotalAddGuestButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 37px;

  border-radius: 5px;
  
  overflow: hidden;
`;

const AddGuestButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.width};
  height: 100%;

  gap: 4px;

  background-color: ${props => props.backgroundColor};

  &:hover {
    cursor: pointer;
  }
`;

const CloseButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 77px;
  height: 37px;

  background-color: ${props => props.theme.buttonFill};

  border-radius: 5px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledPlus = styled(PlusSvg)`
  flex-shrink: 0;
  width: 17px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const GuestPhoneInputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  gap: 8px;
`;
